import notifications from '~/vue/plugins/notifications';
import globalEventBus, {GLOBAL_EVENTS} from 'shared/globalEventBus';
import WsNewConversationMessageNotification
    from '../../angular/app/ws_messages/WsNewConversationMessageNotification.vue';

let audio = new Audio('/static/audio/message_sound.mp3');

function playNotification() {
    audio.load();
    try {
        audio.play(); // ios no interaction error message possible.
    } catch (e) {
    }
}

export const onNewConversationMessageDefaultListener = async (e) => {
    /**
     * @param {LiveEventNewConversationMessage} e
     */
    console.log(e);
    notifications.Notification({
        delay: 8000,
        title: 'New Message',
        component: WsNewConversationMessageNotification,
        props: {msg: e}
    });
    globalEventBus.emit(GLOBAL_EVENTS.CONVERSATIONS_UNREAD_COUNT_INCREASED, e.conversation_id);
    playNotification();
};
